var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13917_9178",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 21,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.08993C11.7767 9.08993 11.083 9.37727 10.5715 9.88873C10.0601 10.4002 9.77273 11.0939 9.77273 11.8172C9.77273 12.5405 10.0601 13.2342 10.5715 13.7457C11.083 14.2571 11.7767 14.5445 12.5 14.5445C13.2233 14.5445 13.917 14.2571 14.4285 13.7457C14.9399 13.2342 15.2273 12.5405 15.2273 11.8172C15.2273 11.0939 14.9399 10.4002 14.4285 9.88873C13.917 9.37727 13.2233 9.08993 12.5 9.08993ZM12.5 16.3627C11.2945 16.3627 10.1383 15.8838 9.28588 15.0313C8.43344 14.1789 7.95455 13.0227 7.95455 11.8172C7.95455 10.6117 8.43344 9.45552 9.28588 8.60308C10.1383 7.75065 11.2945 7.27175 12.5 7.27175C13.7055 7.27175 14.8617 7.75065 15.7141 8.60308C16.5666 9.45552 17.0455 10.6117 17.0455 11.8172C17.0455 13.0227 16.5666 14.1789 15.7141 15.0313C14.8617 15.8838 13.7055 16.3627 12.5 16.3627ZM12.5 4.99902C8.08182 4.99902 4.11818 7.7263 2.5 11.8172C4.67273 17.3445 10.9091 20.0536 16.4364 17.8808C19.2091 16.7899 21.4091 14.599 22.5 11.8172C20.8818 7.7263 16.9182 4.99902 12.5 4.99902Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13917_9178)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#00538F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.eabf87a026dfab81fd902f6e54f3365b.svg";
export { ForwardRef as ReactComponent };